import type { BehaviorSubject, ReplaySubject, Subject } from 'rxjs';

export function transferRxNext<T>(stream$: Subject<T> | BehaviorSubject<T> | ReplaySubject<T>) {
  return (value: T): void => stream$.next(value);
}
